import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SyncUserContentProgressMutationVariables = Types.Exact<{
  input: Types.SyncUserContentProgressInput;
}>;


export type SyncUserContentProgressMutation = { syncUserContentProgress: { success?: boolean | null, jobScheduleId: string } };


export const SyncUserContentProgressDocument = /*#__PURE__*/ gql`
    mutation syncUserContentProgress($input: SyncUserContentProgressInput!) {
  syncUserContentProgress(input: $input) {
    success
    jobScheduleId
  }
}
    `;

export function useSyncUserContentProgressMutation() {
  return Urql.useMutation<SyncUserContentProgressMutation, SyncUserContentProgressMutationVariables>(SyncUserContentProgressDocument);
};